<template>
  <div>
    <span class="title-grid-info mb-2 mt-5" v-if="data?.length > 0">
      {{ sTitulo }}
    </span>
    <v-row>
      <v-col cols="12" v-if="bFilter || bExportar" class="d-flex justify-space-between">
        <v-row no-gutters>
          <v-col sm="12" md="5" lg="5" xl="5">
            <v-text-field
              v-if="bFilter"
              v-model="search"
              append-icon="mdi-magnify"
              label="Búsqueda rápida"
              single-line
              hide-details
              outlined
              dense
              rounded
              @input="onSearchInput"
            />
          </v-col>
          <v-col class="d-flex justify-end">
            <slot name="btn_exportar"></slot>
          </v-col>
        </v-row>
        
      </v-col>
      <v-col cols="12">
        <v-data-table
          v-model="selected"
          v-bind="attrs"
          :headers="columns"
          :items="cmp_data"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          :show-select="showSelect"
          :item-key="customID"
          :footer-props="{ 'items-per-page-text': 'Registros por página'}"
          no-data-text="Sin información"
          @update:options="updateOptions"
        >
        <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <slot name="btn_personalizado" :item="item" :v-on="on" v-bind="attrs"></slot>
              </template>
              <span> {{ sTooltip }} </span>
            </v-tooltip>
        </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "info-grid-asignaciones",
  props: {
    attrs: {
      type: Object,
      default: () => ({}),
    },
    sTitulo: {
      type: String,
      default: "",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    customID: {
      type: String,
      default: "id",
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    bFilter: {
      type: Boolean,
      default: false
    },
    sTooltip: {
      type: String,
      default: () => ''
    },
    bExportar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: [],
      totalItems: 0,
      cmp_data: [],
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      search: '',
      debouncedGetData: null,
    };
  },
  methods: {
    updateOptions(newOptions) {
      this.options = newOptions;
      this.getDataFromApi();
    },
    onSearchInput() {
      clearTimeout(this.debouncedGetData);
      this.cmp_data = []
      this.debouncedGetData = setTimeout(() => {
        this.options.page = 1;
        this.$nextTick(() => {
          this.getDataFromApi();
        });
      }, 300);
    },
    getDataFromApi() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;    
      // Simular llamada a API
      setTimeout(() => {
        let filteredData = [...this.data];
        // Aplicar búsqueda si existe
        if (this.search) {
          filteredData = filteredData.filter(item => 
            Object.values(item).some(value => 
              String(value).toLowerCase().includes(this.search.toLowerCase())
            )
          );
        }
        
        // Aplicar ordenamiento
        if (sortBy.length === 1 && sortDesc.length === 1) {
          const sortColumn = sortBy[0];
          const sortDirection = sortDesc[0] ? -1 : 1;
          filteredData.sort((a, b) => {
            const valueA = a[sortColumn];
            const valueB = b[sortColumn];
            if (typeof valueA === 'string' && typeof valueB === 'string') {
              return sortDirection * valueA.localeCompare(valueB, 'es', { sensitivity: 'case' });
            } else {
              return sortDirection * (valueA > valueB ? 1 : valueA < valueB ? -1 : 0);
            }
          });
        }
        
        // Calcular el total de items
        this.totalItems = filteredData.length;
        
        // Aplicar paginación
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        this.cmp_data = itemsPerPage === -1 ? filteredData : filteredData.slice(startIndex, endIndex);
        this.loading = false;
      }, 600);
    },
    _onDisconnect(id) {
      if (typeof id !== "undefined") this.$emit("onDelete", id);
    },
    _onPaste() {
      this.$emit('onPaste', this.selected)      
    }
  },
  watch: {
    data: {
      handler() {
        this.getDataFromApi();
      },
      immediate: true,
    },
  },
};
</script>

<style>
.title-grid-info {
  color: #000 !important;
  font-size: 1.25rem !important;
  font-weight: 500;
}
.empty-message {
  width: 50%;
}
</style>